import React from "react";
import Link from "next/link";

import Icon from "../../../common/Icon/Icon";
import Typography from "../../../common/Typography/Typography";

interface Props {
    siteId: string;
    siteName: string;
    actionCount: number;
}

const SitePreviewItem = ({ siteId, siteName, actionCount }: Props) => (
    <Link
        href={`/sites/${siteId}`}
        className="flex flex-row justify-between items-center py-1 grow border-b border-b-pine-900 last-of-type:border-none min-h-[5.7rem]"
    >
        <div>
            <Typography as="p" variant="paragraph">
                {siteName}
            </Typography>
            <span className="type-small-caps">{actionCount}</span> <span className="text-pine-600 type-meta">actions</span>
        </div>
        <Icon icon="chevron_right" />
    </Link>
);

export default SitePreviewItem;
